<template>
    <section class="single-info is-hidden-mobile" v-if="playlist.pitch_group_emails || playlist.emails">
      <div class="level">
        <div class="level-left">
          <h3 class="m-b-30">Emails</h3>
        </div>
        <div class="level-right" v-if="playlist.pitch_group_emails.length || playlist.emails.length">
          <a class="is-primary" @click="showEmails !== 1 ? showEmails = 1 : showEmails = 0">
            <IconArrowUp v-if="showEmails === 0"/>
            <IconArrowDown v-if="showEmails === 1"/>
          </a>
        </div>
      </div>
        <div class="level" v-if="showEmails === 0 && (playlist.pitch_group_emails.length || playlist.emails.length)">
          <div class="level-left">
          <p>There are {{playlist.pitch_group_emails.length + playlist.emails.length}} emails for this playlist.</p>
          </div>
        </div>
        <div class="level" v-if="showEmails === 0 && !playlist.pitch_group_emails.length && !playlist.emails.length">
          <div class="level-left">
          <p>No emails to display.</p>
          </div>
        </div>
        <table class="table is-hoverable is-fullwidth" v-if="showEmails === 1 && (playlist.pitch_group_emails.length || playlist.emails.length)">
          <thead class="is-size-7 is-sortable-column">
            <tr>
            <th class="has-text-grey-light">Sent By</th>
            <th class="has-text-grey-light">Recipient</th>
            <th class="has-text-grey-light">Sent At</th>
            <th class="has-text-grey-light">Status</th>
            <th class="has-text-grey-light">View Count</th>
            <th class="has-text-grey-light">Password Protected</th>
            <th class="has-text-grey-light">Password</th>
            </tr>
          </thead>
          <tbody
            v-for="email in [...(playlist.pitch_group_emails || []), ...(playlist.emails || [])]"
            :key="email.id"
            :pitch="email">
            <tr class="is-clickable">
              <td  @click="email.type === 'Wrios\\Models\\PitchGroup' ? openPitchGroupEmail(email) : null">{{ email.created_by | orBlank('full_name')}}</td>
              <td  @click="email.type === 'Wrios\\Models\\PitchGroup' ? openPitchGroupEmail(email) : null">{{ email.contact | orBlank('full_name') }}</td>
              <td  @click="email.type === 'Wrios\\Models\\PitchGroup' ? openPitchGroupEmail(email) : null">{{ formatDate(email.created_at) }}</td>
              <td  @click="email.type === 'Wrios\\Models\\PitchGroup' ? openPitchGroupEmail(email) : null">{{ email.status | snakeToTitle }}</td>
              <td  @click="email.type === 'Wrios\\Models\\PitchGroup' ? openPitchGroupEmail(email) : null">{{ email.view_count }}</td>
              <td  @click="email.type === 'Wrios\\Models\\PitchGroup' ? openPitchGroupEmail(email) : null">{{ email.password_protected ? 'Yes' : 'No' }}</td>
              <td>{{ email.password }} <a v-if="canEditEmailPassword(email)" class="tooltip" :data-tooltip="email.password_protected ? 'Edit Password' : 'Add Password'" @click="editPassword(email)">
                <IconEdit style="width: 15px; height: 15px;"/>
              </a></td>
            </tr>
          </tbody>
        </table>
    <form-modal
      type="editEmailPassword"
      :title="formTitle"
      :model="selectedEmail"
      :isModal="isModal"
      v-on:clear-modal="clearModal"
      v-on:save-record="save"
    ></form-modal>
    </section>
</template>

<script>
import { IconArrowUp, IconArrowDown, IconEdit } from '@/Icons/IconBase'
import { EMAIL_UPDATE, PLAYLIST_READ } from '@/store/actions'

export default {
  name: 'PitchGroupEmailsPlaylist',
  props: ['playlist'],
  components: {
    IconArrowUp,
    IconArrowDown,
    IconEdit
  },
  data() {
    return {
      showEmails: 0,
      selectedEmail: {},
      isModal: false,
      formTitle: 'Edit Password'
    }
  },
  computed: {
    canEditEmailPassword() {
      return (email) => {
        let currentUser = Object.assign({}, this.$store.getters.getProfile)
        return email.created_by.id === currentUser.id
      }
    }
  },
  methods: {
    openPitchGroupEmail(email) {
      this.$router.push({ name: 'pitch-group.show', params: { id: email.pitch_group_id, email: email } })
    },
    formatDate(dateString) {
      const date = new Date(dateString)
      return date.toLocaleString()
    },
    editPassword(email) {
      this.selectedEmail = email
      this.isModal = true
      this.formTitle = 'Edit Password'
    },
    clearModal() {
      this.isModal = false
    },
    save(data) {
      this.$store.dispatch(EMAIL_UPDATE, {
        id: this.selectedEmail.id,
        data: data
      }).then(() => {
        this.$store.dispatch(PLAYLIST_READ, this.playlist.id)
      })
      this.clearModal()
    }
  }
}
</script>
